function wowo($) {
    setTimeout(function () {
      jQuery("html").addClass("show-c");
      var wTop = jQuery(window).scrollTop(),
        wHeight = jQuery(window).height(),
        wBottom = wTop + wHeight;
      jQuery(".wowo:not(.animated)").each(function () {
        var me = jQuery(this),
          meTop = me.offset().top,
          meHeight = me.height(),
          meBottom = meTop + meHeight,
          limitTop = wTop - meHeight,
          limitBottom = wBottom + meHeight;
        if (meTop > limitTop && meBottom < limitBottom) {
          me.addClass("animated");
  
          setTimeout(function () {
            //me.removeClass("animated wowo");
          }, 1500);
        }
      });
  
    
    }, 100);
  }
  function customParallx() {



        let ticking = false;
        const logosSections = document.querySelectorAll('.logos-sec');
        function optimizedParallax() {
            let wh = $(window).height();
            if (!ticking) {
                requestAnimationFrame(() => {
                    const scrollY = window.scrollY;
                    const isSmallScreen = window.innerWidth > 575;
                    logosSections.forEach(el => {
                        if (isSmallScreen) {
                            const elementTop = el.getBoundingClientRect().top + scrollY;
                            const parallaxY = (elementTop  - wh - scrollY) / 24;
                            el.style.setProperty('--transformY', `${parallaxY}px`);
                        } else {
                            el.style.setProperty('--transformY', '0');
                        }
                    });
                    
                    ticking = false;
                });
                ticking = true;
            }
        }
        
        window.addEventListener('scroll', optimizedParallax, { passive: true });
        window.addEventListener('resize', optimizedParallax);
        

}
  function swiper() {
    if ($("#swiper1").length) {
      var swiper1 = new Swiper("#swiper1", {
        loop: true,
        speed: 500,
        grabCursor: true,
        slidesPerView: "2",
        touchEventsTarget: "container",
        // freeMode: true,
        spaceBetween: 20,
        autoplay:true,
        slideToClickedSlide: false,
        mousewheel: {
          forceToAxis: true,
          thresholdDelta: 15,
          sensitivity: 0.8,
          eventsTarget: "container",
        },
        simulateTouch: true,
        touchRatio: 1,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: " .slider-content .swiper-button-next",
          prevEl: " .slider-content .swiper-button-prev",
        },
        
        breakpoints: {
          1200: {
            slidesPerView: "4",
            spaceBetween: 30,
          },
          767: { slidesPerView: "3" },
          575: {
            slidesPerView: "2",
          },
        },   on: {
            init: function () {
                let modalsContainer = document.getElementById('modals-container');
                if (!modalsContainer) {
                  modalsContainer = document.createElement('div');
                  modalsContainer.id = 'modals-container';
                  document.body.appendChild(modalsContainer);
                }
          
                const slides = this.slides;
                slides.forEach(slide => {
                  const modals = slide.querySelectorAll('.modal');
                  modals.forEach(modal => {
                    modal.remove();
                    modalsContainer.appendChild(modal);
                  });
                });
              },
          }
      
      });
    }
  }
  
  function marquee() {
    Marquee3k.init({ selector: "marquee3k" });
  
    document.querySelectorAll(".marquee3k").forEach((el) => {
      el.addEventListener("mouseenter", () => {
         Marquee3k.pauseAll();
      });
  
      el.addEventListener("mouseleave", () => {
        Marquee3k.playAll();
      });
    });
  }
  
  function resizeWindow() {
    const $items = $('.shop-slider .swiper-slide');
    let maxHeight = 0;

    $items.each((index, element) => {
        const textHeight = $(element).find('.grid-product__link').height() || 0;
        if (textHeight > maxHeight) maxHeight = textHeight;
    });

    $('.slider-content').attr('style', '--h:' + maxHeight + 'px');
  }
  var $ = jQuery.noConflict();
  jQuery(document).ready(function () {
    wowo();
    swiper();
    marquee();resizeWindow()
  //  customParallx()
    jQuery(window).scroll(function () {
      wowo();
    });
    jQuery(window).resize(function () {
      // marquee()
      resizeWindow()
    });
  });
  